"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentDate = exports.getCurrentMsByEndTime = exports.getCurrentMsByTime = exports.isSameDay = exports.getStartAndEndCurrentDay = exports.getCurrentDayLong = exports.getCurrentDay = exports.getDifferenceBetweenDates = exports.getCurrentWeek = exports.isDST = exports.addMonths = exports.addDays = exports.syncHours = void 0;
const lunchLists_1 = require("../types/lunchLists");
/**
 * Helper function to sync ISO-date hours between original and future recurring date.
 * - If both dates are in the same DST, return new date
 * - If original date is set in summer time (FIN +3) and recurring date is in winter time (FIN +2),
 * return new date with + 1 hours.
 * - If original date is set in winter time and recurring date is in summer time, return date with -1 hours
 * @param originalDateString Original start/end string set for e.g channel item
 * @param newDate New recurring date
 */
const syncHours = (originalDateString, newDate) => {
    const originalDate = new Date(originalDateString);
    if (isDST(originalDate) && !isDST(newDate)) {
        const newDateSynced = new Date(newDate);
        newDateSynced.setUTCHours(newDateSynced.getUTCHours() + 1);
        return newDateSynced;
    }
    else if (isDST(newDate) && !isDST(originalDate)) {
        const newDateSynced = new Date(newDate);
        newDateSynced.setUTCHours(newDateSynced.getUTCHours() - 1);
        return newDateSynced;
    }
    return newDate;
};
exports.syncHours = syncHours;
/** Add x-amount of days to provided date object, return new date */
const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
exports.addDays = addDays;
/** Add x-amount of months to provided date object, return new date */
const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
};
exports.addMonths = addMonths;
/** Function to determine if given date is in DST (Daylight Saving Time) or not */
const isDST = (d) => {
    const jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) != d.getTimezoneOffset();
};
exports.isDST = isDST;
/**
 * Get current week index depending on the amount of weeks in a LunchList
 * @param startDate Start of the rotational LunchList (as UTC string)
 * @param dateNow Current date (as UTC)
 * @param weekAmount amount of weeks in LunchList's weeks array
 * @returns undefined if startDate is in the future
 */
const getCurrentWeek = (startDate, dateNow, weekAmount) => {
    const start = new Date(startDate);
    const difference = getDifferenceBetweenDates(start, dateNow);
    const currentIndex = difference % weekAmount;
    return difference >= 0 ? currentIndex : undefined;
};
exports.getCurrentWeek = getCurrentWeek;
/**
 * Get difference in weeks between two days.
 * @param a must be a Monday at midnight in UTC.
 * e.g 2020-08-24T00:00:00.000Z
 * @param b what ever date after parameter a
 */
const getDifferenceBetweenDates = (a, b) => {
    const ONE_DAY = 1000 * 60 * 60 * 24;
    const ONE_WEEK = ONE_DAY * 7;
    const diffInWeeks = (b.getTime() - a.getTime()) / ONE_WEEK;
    return Math.floor(diffInWeeks);
};
exports.getDifferenceBetweenDates = getDifferenceBetweenDates;
/**
 * Get current day. Returns abbreviation as in 'mon' or 'tue' etc..
 * @param date
 */
const getCurrentDay = (date) => {
    const currentDay = date.getDay();
    const days = Object.values(lunchLists_1.LunchListWeekDay);
    return days[currentDay];
};
exports.getCurrentDay = getCurrentDay;
const getCurrentDayLong = (timeMs) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dIndex = new Date(timeMs).getDay();
    return days[dIndex];
};
exports.getCurrentDayLong = getCurrentDayLong;
/**
 * Get start and end dates from current day
 * @param date
 */
const getStartAndEndCurrentDay = (date) => {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return {
        endDate: end.toISOString(),
        startDate: start.toISOString()
    };
};
exports.getStartAndEndCurrentDay = getStartAndEndCurrentDay;
/**
 * Check if given two dates are in the same day
 * @param d1
 * @param d2
 */
const isSameDay = (d1, d2) => d1.getUTCFullYear() === d2.getUTCFullYear() &&
    d1.getUTCMonth() === d2.getUTCMonth() &&
    d1.getUTCDay() === d2.getUTCDay();
exports.isSameDay = isSameDay;
const getCurrentMsByTime = (currentTimeMs, d) => {
    const currentDateTime = new Date(currentTimeMs);
    const hours = d.getHours();
    const minutes = d.getMinutes();
    currentDateTime.setHours(hours);
    currentDateTime.setMinutes(minutes);
    return currentDateTime.getTime();
};
exports.getCurrentMsByTime = getCurrentMsByTime;
/**
 * Get current end time for date in MS.
 * 59 seconds and 999 milliseconds are added to end date to make sure
 * that schedule displays the full last minute.
 */
const getCurrentMsByEndTime = (currentTimeMs, d) => {
    const currentDateTime = new Date(currentTimeMs);
    const hours = d.getHours();
    const minutes = d.getMinutes();
    currentDateTime.setHours(hours);
    currentDateTime.setMinutes(minutes);
    currentDateTime.setSeconds(59);
    currentDateTime.setMilliseconds(999);
    return currentDateTime.getTime();
};
exports.getCurrentMsByEndTime = getCurrentMsByEndTime;
/**
 * get current JS Date. This function is used to enable mocking date
 */
const getCurrentDate = () => new Date();
exports.getCurrentDate = getCurrentDate;
//# sourceMappingURL=date.js.map